import cookie from 'js-cookie'

import config from '../config'

export const TOKEN_KEY = 'wfeToken'

const wasLoggedIn = () => {
  try {
    const token = cookie.get(TOKEN_KEY)
    if (!token) {
      throw new Error('no token in local storage')
    }
    const [, jwtBody] = token.split('.')
    const { cheggTokens } = JSON.parse(atob(jwtBody))
    return !!(cheggTokens && cheggTokens.access_token)
  } catch (e) {
    return false
  }
}

const endpoint = () => {
  const path = wasLoggedIn() ? '/auth/refresh' : '/auth/token'
  return `${config.getCfeApiUrl()}${path}?client=wbe`
}

const cookieDomain = () => {
  const url = config.getCfeApiUrl()
  if (/easybib/.test(url)) {
    return '.easybib.com'
  } else if (/bibme/.test(url)) {
    return '.bibme.org'
  } else if (/citationmachine/.test(url)) {
    return '.citationmachine.net'
  }
  return ''
}

const isLocalhost = /localhost/.test(typeof window !== 'undefined' && window.location.hostname)
const wfeTokenRefresh = async response => {
  const { status } = response

  if (status === 401 || status === 403) {
    const updateHostApp = config.getOnCfeAuthUpdate()

    const authResponse = await fetch(endpoint(), {
      method: 'post',
      credentials: 'include',
    })
    const data = await authResponse.json()

    cookie.set(TOKEN_KEY, data.jwt, {
      path: '/',
      domain: !isLocalhost ? cookieDomain() : undefined, // Cannot set .easybib.com cookie from localhost
    })

    // This is necessary to keep the redux store in sync in the host app with the widget.
    // To call set user incase anything has changed
    if (updateHostApp) {
      updateHostApp(data.jwt)
    }
    return Promise.resolve()
  }
  return Promise.reject(new Error(JSON.stringify({ status: response.status })))
}

export default wfeTokenRefresh
